import React from 'react';
import Bone, { SectionHeaderBone } from './Bone';

/** Placeholder for a titled card holding a list (activity, notifications, sections). */
export default function CardSkeleton({ rows = 5 }) {
    return (
        <div className="shelf-card mb-4" aria-busy="true">
            <SectionHeaderBone />
            <div className="divide-y divide-surface-100">
                {Array.from({ length: rows }).map((_, index) => (
                    <div key={index} className="flex items-center gap-3 px-5 py-3.5">
                        <Bone className="h-2 w-2 rounded-full shrink-0" />
                        <div className="flex-1 min-w-0 space-y-2">
                            <Bone className="h-3.5" style={{ width: `${45 + ((index * 17) % 30)}%` }} />
                            <Bone className="h-3 w-1/4" />
                        </div>
                        <Bone className="h-6 w-20 shrink-0" />
                    </div>
                ))}
            </div>
        </div>
    );
}
